import * as React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const VOLLEY_LOGO_URL = new URL(
    "../../static/img/icon-volley-green.png",
    import.meta.url,
);

interface Props {
    open?: boolean;
}

export default function Loading({ open = true }: Props): React.JSX.Element {
    const theme = useTheme();

    return (
        <Dialog
            fullScreen
            open={open}
            slotProps={{
                paper: { sx: { background: theme.palette.primary.main } },
            }}
            transitionDuration={{ exit: 400 }}
        >
            <Stack
                spacing={2}
                alignItems="center"
                justifyContent="center"
                sx={{ height: "90vh" }}
            >
                <img
                    src={VOLLEY_LOGO_URL.toString()}
                    alt="green volley logo"
                    height={60}
                />
                <Typography variant="h3" color="white" sx={{ mt: 2, mb: 4 }}>
                    Loading ...
                </Typography>
                <CircularProgress color="secondary" />
            </Stack>
        </Dialog>
    );
}
